import { cropImageAPI } from '@/utils/api';
import { buildCropImageSavePayload } from '../utils/imageCropRowStatus';
import { rememberImageCropResult } from '../utils/imageCropResultCache';

/**
 * Studio / 重试完成后写入 crop-images，与详情页 runImageCropTaskBatch 落库一致。
 * 须在 completeStudioImageTaskUpdate（OSS ingest）之后调用，outputs 使用 ingest 后的 canonical URL。
 */
export async function persistImageCropStudioOutputs({
  taskId,
  sources = [],
  imageUrls = [],
  outputs = [],
}) {
  if (!taskId) return;

  await Promise.all(outputs.map(async (output, index) => {
    const imageId = String(output.sourceImageId || sources[index]?.id || `crop-${index}`).trim();
    const originalImageUrl = String(imageUrls[index] || sources[index]?.url || '').trim();
    try {
      if (output.status === 'success') {
        const croppedImageUrl = String(
          output.url || output.outputUrl || output.imageUrl || '',
        ).trim();
        await cropImageAPI.save(
          taskId,
          buildCropImageSavePayload({
            imageId,
            originalImageUrl,
            croppedImageUrl,
            status: 'success',
          }),
        );
        rememberImageCropResult(taskId, imageId, {
          imageId,
          originalUrl: originalImageUrl,
          croppedUrl: croppedImageUrl,
          status: 'success',
        });
        return;
      }

      await cropImageAPI.save(
        taskId,
        buildCropImageSavePayload({
          imageId,
          originalImageUrl,
          status: 'failed',
          error: output.error || '裁剪失败',
        }),
      );
    } catch (error) {
      console.warn('[图案裁剪 Studio] crop-images 保存失败', taskId, imageId, error);
    }
  }));
}
